// List of organization IDs that have the "Powered By" logo, to avoid asynchronous search.
export const poweredByOrgs: (number|undefined)[] = [
    35,
]